import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import PDPProductDetailsLinkSection from '../PDPProductDetailsModal/PDPProductDetailsLinkSection';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';

// Details tab: the construction list that today only exists inside the
// details-and-care full-screen modal
const PDPInfoDetailsSection = () => {
  const $ = _c(12);
  const {
    data: t0
  } = useProductAttributes();
  const {
    constructionDetails,
    productPDF,
    assemblyDetailsPDF
  } = t0;
  const tearSheetLink = productPDF ? `https://jb-img.co/public_img/${productPDF}` : undefined;
  const assemblyDetailsLink = assemblyDetailsPDF ? `https://jb-img.co/public_img/${assemblyDetailsPDF}` : undefined;
  let t1;
  if ($[0] !== constructionDetails) {
    t1 = constructionDetails ?? [];
    $[0] = constructionDetails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = t1.map(_temp);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="md:[column-count:2] md:[column-gap:3rem]">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== assemblyDetailsLink || $[7] !== tearSheetLink) {
    t4 = (!!tearSheetLink || !!assemblyDetailsLink) && <div className="mt-6 flex flex-row gap-6 max-[767px]:flex-col"><PDPProductDetailsLinkSection dataXc="PDPTearSheetLink" link={tearSheetLink}>Download Tear Sheet</PDPProductDetailsLinkSection><PDPProductDetailsLinkSection link={assemblyDetailsLink}>Download Assembly Details</PDPProductDetailsLinkSection></div>;
    $[6] = assemblyDetailsLink;
    $[7] = tearSheetLink;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <PDPInfoSectionLayout>{t3}{t4}</PDPInfoSectionLayout>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default PDPInfoDetailsSection;
function _temp(t0) {
  const {
    label,
    description
  } = t0;
  return <div key={`${label}:${description}`} className="break-inside-avoid mb-6"><div className="text-sm font-bold text-gray">{label}</div><div className="text-sm text-gray pb-0">{description}</div></div>;
}